import { Check, Copy } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/Button";
import { Dialog } from "@/components/ui/Dialog";

export function TemporaryPasswordDialog({
  title,
  password,
  onClose,
}: {
  title: string;
  password: string | null;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    if (!password) return;
    try {
      await navigator.clipboard.writeText(password);
      setCopied(true);
    } catch {
      // clipboard unavailable (insecure context): the password stays selectable on screen
    }
  };
  return (
    <Dialog
      open={password !== null}
      onOpenChange={(open) => {
        if (!open) {
          setCopied(false);
          onClose();
        }
      }}
      title={title}
      description={t("admin.users.temporaryPasswordBody")}
      footer={<Button onClick={onClose}>{t("common.close")}</Button>}
    >
      <p className="mb-2 text-sm font-medium">{t("admin.users.temporaryPassword")}</p>
      <div className="flex items-center gap-2">
        <code className="flex-1 rounded-control bg-sunken px-3 py-2.5 text-base font-medium tracking-wide break-all select-all">
          {password}
        </code>
        <Button variant="secondary" onClick={() => void copy()}>
          {copied ? (
            <Check className="size-4" aria-hidden="true" />
          ) : (
            <Copy className="size-4" aria-hidden="true" />
          )}
          {copied ? t("common.copied") : t("common.copy")}
        </Button>
      </div>
    </Dialog>
  );
}
